import ff from './ff';

export default class c00d {

static d_defs = {

/*
  DROP TABLE t_c00r;
  CREATE TABLE t_c00r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    c00rb21f INTEGER,
    c00rc11s TEXT,
    c00ri11s TEXT,
    c00rt11i INTEGER,
    c00ri11i INTEGER,
    c00ri11t TEXT,
    c00ri21s TEXT,
    c00rcx1i INTEGER,
    c00rcy1t TEXT,
    c00rcy1f INTEGER,
    c00rcz1i INTEGER
  );
  INSERT INTO t_c00r (c00rb21f, c00rt11i, c00rc11s) VALUES (1, 10, 'dantai1');
  INSERT INTO t_c00r (c00rb21f, c00rt11i, c00rc11s) VALUES (1, 20, 'staff1');
  INSERT INTO t_c00r (c00rb21f, c00rt11i, c00rc11s) VALUES (0, 90, 'kanri1');
*/

  c00r: {
    0: {
      pfx: '認証情報',
      dd_fldDefss: {
        c00rb21f: { // c20r_fst オプション
          pfx: '利用会社',
        },
        c00rt11i: {
          pfx: '利用者区分',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '団体' },
            { key: 20, pfx: 'スタッフ' },
            { key: 90, pfx: '管理' },
          ],
        },
        c00rc11s: { // メールアドレス・ID
          pfx: 'ID',
          type: 'Inp',
          n_col: 6,
        },
        c00ri11s: { // パスワード
          pfx: '確認コード',
          type: 'Inp',
        },
        c00ri11i: {
          pfx: '確認回数',
          type: 'Inp',
        },
        c00ri11t: {
          pfx: '確認日時', // 前回確認日時
          type: 'Inp',
        },
        c00ri21s: {
          pfx: 'トークン番号',
          type: 'Inp',
        },
      },
    },
  },

/*
  DROP TABLE t_c01r;
  CREATE TABLE t_c01r (_key SERIAL PRIMARY KEY, _vsn INTEGER, _ltt INTEGER, _fst INTEGER, 
    c01rb21f INTEGER,
    c01rc11s TEXT,
    c01rt11i INTEGER,
    c01rt21i INTEGER,
    c01rcx1i INTEGER,
    c01rcy1t TEXT,
    c01rcy1f INTEGER,
    c01rcz1i INTEGER
    , CONSTRAINT c01r_unq1 UNIQUE (c01rb21f, c01rt11i)
  );
  INSERT INTO t_c01r (c01rb21f, c01rc11s, c01rt11i, c01rt21i) VALUES (0, 'kanri', 90, 10);
  INSERT INTO t_c01r (c01rb21f, c01rc11s, c01rt11i, c01rt21i) VALUES (1, 'c-aobadai', 10, 10);
  INSERT INTO t_c01r (c01rb21f, c01rc11s, c01rt11i, c01rt21i) VALUES (1, 'c-aobadai-staff', 20, 20);
*/
//  INSERT INTO t_c01r (c01rb21f, c01rc11s, c01rt11i, c01rt21i) VALUES (1, 'd-ufrsw', 10, 10);
//  INSERT INTO t_c01r (c01rb21f, c01rc11s, c01rt11i, c01rt21i) VALUES (1, 's-ufrsw', 20, 20);

  c01r: {
    0: {
      pfx: 'サブドメイン情報',
      dd_fldDefss: {
        c01rb21f: { // c20r_fst
          pfx: '利用会社',
        },
        c01rc11s: { // サブドメイン
          pfx: 'ID',
          type: 'Inp',
          n_col: 6,
          lo_qrys: [
            _d_vals => { // クライアント情報を元に、サブドメインを設定
              let _qry =     `
                INSERT INTO
                  t_c01r
                (
                  c01rb21f,
                  c01rc11s,
                  c01rt11i,
                  c01rt21i
                ) VALUES (
                  ${_d_vals.c01rb21f},
                  "${_d_vals.c01rc11s}",
                  ${_d_vals.c01rt11i},
                  ${_d_vals.c01rt21i}
                )
                ON CONFLICT ON CONSTRAINT c01r_unq1
                DO UPDATE SET
                  c01rc11s = "${_d_vals.c01rc11s}"
                  , c01rt21i = ${_d_vals.c01rt21i}
                WHERE
                  t_c01r.c01rb21f = ${_d_vals.c01rb21f}
                  AND t_c01r.c01rt11i = "${_d_vals.c01rt11i}"
              `;
//ff.l('113: {}'.f(_qry))
              return _qry;
            },
          ],
        },
        c01rt11i: {
          pfx: '利用者区分',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: '団体' },
            { key: 20, pfx: 'スタッフ' },
            { key: 90, pfx: '管理' },
          ],
        },
        c01rt21i: {
          pfx: '認証区分',
          type: 'Pck',
          ld_iss: [
            { key: -1, pfx: ' ' },
            { key: 10, pfx: 'メールアドレス・確認コード' },
            { key: 20, pfx: 'ID・パスワード' },
          ],
        },
      },
    },
  },

};

};
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
